/** ui: English + Arabic (Arabic is a draft for native review). Generated/merged by the i18n helper; edit freely. */
const en = {
  "pages": "Pages",
  "range": "{from}–{to} of {total}",
  "perPage": "Per page",
  "prevPage": "Previous page",
  "nextPage": "Next page",
  "firstPage": "First page",
  "lastPage": "Last page",
  "goToPage": "Page number (1 to {n}); press Enter to go",
  "prev": "‹ Prev",
  "next": "Next ›",
  "selectAllRows": "Select all rows",
  "selectRow": "Select row {key}",
  "actions": "Actions",
  "comfortableRows": "Comfortable rows",
  "compactRows": "Compact rows",
  "toComfortable": "Switch to comfortable rows",
  "toCompact": "Switch to compact rows",
  "nothingYet": "Nothing here yet.",
  "discardChanges": "You have unsaved changes. Discard them?",
  "closePanel": "Close panel",
  "uploads": "Uploads",
  "uploadingN": "Uploading {n} item | Uploading {n} items",
  "optimizingN": "Optimizing {n} item | Optimizing {n} items",
  "failedN": "{n} upload failed | {n} uploads failed",
  "completeN": "{n} upload complete | {n} uploads complete",
  "andFailed": " · {n} failed",
  "sentOf": "{sent} of {size}",
  "waitOptimize": "Waiting to optimize · can’t be published yet",
  "optimizingPct": "Optimizing for players · {pct}%",
  "readyToPublish": "Ready to publish",
  "cancelled": "Cancelled",
  "failed": "Failed",
  "cancelUnfinished": "Cancel the uploads that haven’t finished?",
  "expandUploads": "Expand uploads",
  "collapseUploads": "Collapse uploads",
  "closeUploads": "Close uploads",
  "uploadsHint": "Files appear in Content right away and can be published once optimizing finishes.",
  "cancelName": "Cancel {name}",
  "uploadingName": "Uploading {name}",
  "optimizingName": "Optimizing {name}",
  "ready": "Ready",
  "dismiss": "Dismiss",
  "content": "Content",
  "folderPath": "Folder path",
  "folders": "Folders",
  "folderTitle": "{name} · {n} item | {name} · {n} items",
  "actionsFor": "Actions for {name}",
  "open": "Open",
  "rename": "Rename",
  "moveTo": "Move To…",
  "delete": "Delete",
  "moveTitle": "Move {subject} to…",
  "destination": "Destination folder",
  "current": "current",
  "noSelfMove": "A folder can’t move into itself",
  "newFolderIn": "New folder in {parent}",
  "folderName": "Folder name",
  "create": "Create",
  "newFolder": "+ New folder",
  "newFolderInShort": "+ New folder in {parent}",
  "cancel": "Cancel",
  "moving": "Moving…",
  "moveHere": "Move here",
  "folder": "folder",
  "loading": "Loading…",
  "noActivity": "No activity recorded for this item yet.",
  "activity": "Activity",
  "openTag": "See where this tag is used",
  "tagPlayers": "{n} player | {n} players",
  "removeTag": "Remove tag {tag}",
  "addTag": "+ Add a tag",
  "chartAria": "{title} chart. Use the arrow keys to read values.",
  "noData": "No data",
  "offlinePeriod": "⚠ Offline during this period",
  "offlineLegend": "⚠ Offline (no connectivity when sampled)",
  "canvasAria": "Canvas {w}×{h} with {n} zone(s)",
  "today": "Today",
  "yesterday": "Yesterday",
  "systemActor": "Displaro",
  "ok": "OK",
  "km": "{n} km",
  "m": "{n} m",
  "zipChoose": "Choose a .zip file.",
  "zipTooBig": "The zip is larger than {mb} MB.",
  "zipInvalid": "This file is not a valid .zip.",
  "zipManifest": "{file} could not be read.",
  "noResponse": "No response from the server",
  "uploadNetwork": "Network error during upload",
  "uploadCancelled": "Upload cancelled",
  "uploadFailed": "Upload failed ({status})",
  "notOptimized": "The file could not be optimized.",
  "fileDeleted": "The file was deleted.",
  "placeSearchFailed": "Place search failed ({status})"
};
const ar: typeof en = {
  "pages": "الصفحات",
  "range": "{from}–{to} من {total}",
  "perPage": "لكل صفحة",
  "prevPage": "الصفحة السابقة",
  "nextPage": "الصفحة التالية",
  "firstPage": "الصفحة الأولى",
  "lastPage": "الصفحة الأخيرة",
  "goToPage": "رقم الصفحة (من 1 إلى {n})؛ اضغط Enter للانتقال",
  "prev": "السابق ›",
  "next": "‹ التالي",
  "selectAllRows": "تحديد كل الصفوف",
  "selectRow": "تحديد الصف {key}",
  "actions": "الإجراءات",
  "comfortableRows": "صفوف مريحة",
  "compactRows": "صفوف مضغوطة",
  "toComfortable": "التبديل إلى صفوف مريحة",
  "toCompact": "التبديل إلى صفوف مضغوطة",
  "nothingYet": "لا شيء هنا بعد.",
  "discardChanges": "لديك تغييرات غير محفوظة. هل تريد تجاهلها؟",
  "closePanel": "إغلاق اللوحة",
  "uploads": "الرفع",
  "uploadingN": "لا رفع | جارٍ رفع عنصر واحد | جارٍ رفع عنصرين | جارٍ رفع {n} عناصر | جارٍ رفع {n} عنصرًا | جارٍ رفع {n} عنصر",
  "optimizingN": "لا تحسين | جارٍ تحسين عنصر واحد | جارٍ تحسين عنصرين | جارٍ تحسين {n} عناصر | جارٍ تحسين {n} عنصرًا | جارٍ تحسين {n} عنصر",
  "failedN": "لا إخفاق | فشل رفع واحد | فشل رفعان | فشل {n} عمليات رفع | فشل {n} عملية رفع | فشل {n} عملية رفع",
  "completeN": "لا رفع مكتمل | اكتمل رفع واحد | اكتمل رفعان | اكتملت {n} عمليات رفع | اكتملت {n} عملية رفع | اكتملت {n} عملية رفع",
  "andFailed": " · فشل {n}",
  "sentOf": "{sent} من {size}",
  "waitOptimize": "بانتظار التحسين · لا يمكن نشره بعد",
  "optimizingPct": "جارٍ التحسين للمشغلات · {pct}٪",
  "readyToPublish": "جاهز للنشر",
  "cancelled": "أُلغي",
  "failed": "فشل",
  "cancelUnfinished": "إلغاء عمليات الرفع التي لم تكتمل؟",
  "expandUploads": "توسيع الرفع",
  "collapseUploads": "طي الرفع",
  "closeUploads": "إغلاق الرفع",
  "uploadsHint": "تظهر الملفات في المحتوى فورًا، ويمكن نشرها بعد انتهاء التحسين.",
  "cancelName": "إلغاء {name}",
  "uploadingName": "جارٍ رفع {name}",
  "optimizingName": "جارٍ تحسين {name}",
  "ready": "جاهز",
  "dismiss": "تجاهل",
  "content": "المحتوى",
  "folderPath": "مسار المجلد",
  "folders": "المجلدات",
  "folderTitle": "{name} · لا عناصر | {name} · عنصر واحد | {name} · عنصران | {name} · {n} عناصر | {name} · {n} عنصرًا | {name} · {n} عنصر",
  "actionsFor": "إجراءات {name}",
  "open": "فتح",
  "rename": "إعادة تسمية",
  "moveTo": "نقل إلى…",
  "delete": "حذف",
  "moveTitle": "نقل {subject} إلى…",
  "destination": "المجلد الوجهة",
  "current": "الحالي",
  "noSelfMove": "لا يمكن نقل مجلد إلى داخله",
  "newFolderIn": "مجلد جديد في {parent}",
  "folderName": "اسم المجلد",
  "create": "إنشاء",
  "newFolder": "+ مجلد جديد",
  "newFolderInShort": "+ مجلد جديد في {parent}",
  "cancel": "إلغاء",
  "moving": "جارٍ النقل…",
  "moveHere": "النقل هنا",
  "folder": "مجلد",
  "loading": "جارٍ التحميل…",
  "noActivity": "لا يوجد نشاط مسجّل لهذا العنصر بعد.",
  "activity": "النشاط",
  "openTag": "عرض أين يُستخدم هذا الوسم",
  "tagPlayers": "مشغل واحد | {n} مشغلات",
  "removeTag": "إزالة الوسم {tag}",
  "addTag": "+ إضافة وسم",
  "chartAria": "مخطط {title}. استخدم مفاتيح الأسهم لقراءة القيم.",
  "noData": "لا بيانات",
  "offlinePeriod": "⚠ غير متصل خلال هذه الفترة",
  "offlineLegend": "⚠ غير متصل (لا اتصال وقت أخذ العينة)",
  "canvasAria": "لوحة {w}×{h} تحتوي على {n} من المناطق",
  "today": "اليوم",
  "yesterday": "أمس",
  "systemActor": "Displaro",
  "ok": "موافق",
  "km": "{n} كم",
  "m": "{n} م",
  "zipChoose": "اختر ملف ‎.zip.",
  "zipTooBig": "الملف المضغوط أكبر من {mb} ميغابايت.",
  "zipInvalid": "هذا الملف ليس ‎.zip صالحًا.",
  "zipManifest": "تعذّرت قراءة {file}.",
  "noResponse": "لا يوجد رد من الخادم",
  "uploadNetwork": "خطأ في الشبكة أثناء الرفع",
  "uploadCancelled": "تم إلغاء الرفع",
  "uploadFailed": "فشل الرفع ({status})",
  "notOptimized": "تعذّر تحسين الملف.",
  "fileDeleted": "تم حذف الملف.",
  "placeSearchFailed": "فشل البحث عن الأماكن ({status})"
};
export default { en, ar };
